import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { createContext, ReactElement, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import ErrorPage from "../components/ErrorPage/ErrorPage";

interface Props {
  setErrorStatusCode: (code: number) => void | undefined;
  errorStatusCode: number | undefined;
}

export const AuthorizationContext = createContext({} as Props);
export const useErrorStatus = () => useContext(AuthorizationContext);

export const AuthorizationProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const { t } = useTranslation("common");
  const [errorStatusCode, setErrorStatusCode] = useState<number>();

  const renderContent = () => {
    if (errorStatusCode === 401) {
      return (
        <ErrorPage
          title={t("authentication.failed.title")}
          subtitles={[t("authentication.failed.subtitle")]}
          icon={{ Component: WarningAmberIcon, color: "warning" }}
          showBackToHomeLink={false}
          showLoginBtn
          fullPage
        />
      );
    }

    return children;
  };

  return (
    <AuthorizationContext.Provider
      value={{ errorStatusCode, setErrorStatusCode }}
    >
      {renderContent()}
    </AuthorizationContext.Provider>
  );
};
